<ng-container *ngIf="companies$ | withLoading | async as pipedCompanies">
  <ng-container *ngIf="pipedCompanies.value as companies">
    <div class="picker-dropdown width-100pcnt picker-list centered-column-container position-abs"
         *ngIf="companies?.length">
      <div *ngFor="let company of companies; index as i"
           class="centered-row-container-flex-start list-block list-entry row-gap-0p5"
           (click)="selectedCompanyEmitter.emit(company)">
        <div [class.error]="company.logo===errorImageLink || !company.logo" class="width-2 height-2 br-0p3 centered-row-container">
          <img [src]="company.logo" *ngIf="company.logo; else noLogo" (error)="company.logo=errorImageLink">
          <ng-template #noLogo class="centered-row-container">
              <img [src]="errorImageLink">
          </ng-template>
        </div>
        <div
          [attr.data-qa]="'import-structure-selected-company-name-' + i"
          class="start-column-vertically-centered-container width-{{fundNameMaxLength + 2}}">
          <span class="font-2 bold500 overflow-ellipsis">{{company?.name}}</span>
          <app-text-with-tooltip
            class="font-3 main-8 bold400"
            [attr.data-qa]="'fund-name-tooltip' + i"
            [id]="'fund-name-tooltip-' + i"
            [text]="company?.fund?.name"
            [linesCount]="2"
            [customTooltipText]="'Organization: ' + company.org.name + ' • Fund: ' + company.fund.name"
            [isTooltipAlwaysShownOnHover]="true"
          />
        </div>
      </div>
    </div>
  </ng-container>
  <div class="picker-dropdown width-100pcnt picker-list centered-column-container position-abs"
       *ngIf="pipedCompanies.loading">
    <div class="centered-row-container-flex-start list-block list-entry row-gap-0p5">
      <div class="width-2 height-2 br-0p3 error"></div>
      <div class="start-column-vertically-centered-container animation-wrapper column-gap-0p5">
        <div class="bg-main-8 br-1 opacity0p64 width-3 height-0p6"></div>
        <div class="bg-main-8 br-1 opacity0p64 width-7p5 height-0p5"></div>
      </div>
    </div>
  </div>
</ng-container>
